module.exports = __webpack_public_path__ + "static/media/marker-icon-2x-90b117.cb468e8a.png";